function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag3Line = function SvgFlag3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M4 21a1 1 0 1 0 2 0v-4.343l13.339-5.78c1.205-.523 1.205-2.231 0-2.753L6.096 2.385A1.5 1.5 0 0 0 4 3.762zM6 4.523 17.485 9.5 6 14.477z"
  }));
};
export default SvgFlag3Line;